module.exports = __webpack_public_path__ + "static/media/U1-T2-0-0b.ded3c3ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-0-0b.svg
// module id = 497
// module chunks = 0